import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ReceivableReportService {

  constructor(private httpService: HttpService) { }

    getReceivableReportForTable(data: any) {
        const url = `${environment.OrderApiendpoint}/receivable-list?${data}`;
        return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
    }
    getInvoiceListForTable(data: any) {
        const url = `${environment.OrderApiendpoint}/invoice-list?${data}`;
        return this.httpService.get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
    }
    createInvoice(data: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/create-invoice`
        return this.httpService.post(url, data, this.httpService.headers)
    }
    deleteInvoice(id: any) {
        const url = `${environment.OrderApiendpoint}/delete-invoice/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    paidInvoice(id: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/mark-as-paid/${id}`
        return this.httpService.post(url, [], this.httpService.headers)
    }
    // paidBatch(id: any) {
    //     const url = `${environment.OrderApiendpoint}/paid-batch/${id}`;
    //     return this.httpService.put(url,this.httpService.headers)
    //         .pipe(
    //             catchError(this.Errorhandling)
    //         );
    // }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {

            console.error(err.error.message);
        } else {

            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
